import React, { useState } from "react";
import "./ordersuccess.css";
import { Link, useNavigate } from "react-router-dom";

function OrderSuccessPage({ userName, orderId }) {
  const user = localStorage.getItem("userInfo");
  const username = JSON.parse(user);
  const name = username?.name;
  console.log(name);
  console.log(user);
  const navigate = useNavigate();

  return (
    <>
      <div className="order-success-container">
        <img src="tick.png"></img>
        <h1 className="order-success-heading">Hi! &nbsp;{name}</h1>
        <p className="order-success-text">
          Thank you for your order placed! Please note that your order is
          currently being processed and is not yet confirmed. A member of our
          team will contact you shortly to finalize the details and assist you
          further.
        </p>
        {orderId && (
          <p className="order-success-text">
            Your Order ID is{" "}
            <span
              style={{
                color: "#0d6efd",
                fontWeight: "600",
                cursor: "pointer",
              }}
              onClick={() => navigate("/myorders")}
              title="View My Orders"
            >
              {`ADC_${orderId}`}
            </span>
          </p>
        )}
        <Link to={"/"}>
          <button className="btn  btn-danger">Continue Shopping</button>
        </Link>
      </div>
    </>
  );
}

export default OrderSuccessPage;
